if (!customElements.get('testimonials-carousel')) {
  class TestimonialsCarousel extends HTMLElement {

    constructor() {
      super();
      this.initSlider();
    }

    initSlider() {
      const options = {
        container: this.querySelector('[data-slider]'),
        prevButton: this.querySelector('[data-slider-prev]'),
        nextButton: this.querySelector('[data-slider-next]'),
        controls: false,
        nav: true,
        navPosition: 'bottom',
        mouseDrag: true,
        responsive: {
          992: {
            disable: false,
            nav: false,
            preventScrollOnTouch: 'auto',
            controls: true,
            loop: true
          }
        }
      };
      tns(options);
    }
  }
  customElements.define('testimonials-carousel', TestimonialsCarousel);
}